// extracted by mini-css-extract-plugin
export default {"popupWrapper":"popupWrapper__Evdsa","legend":"legend__t22TJ"};